import React from "react";
import "./theme.scss";

export default function RimowaTheme({
  id = "rimowa",
  children
}: {
  id?: "rimowa";
  children?: React.ReactNode | React.ReactNodeArray;
}) {
  return <React.Fragment key={id}>{children}</React.Fragment>;
}
